import state from './state';
import mutations from './mutations';
import getters from './getters';

export default {
    namespaced: true,
    state,
    mutations,
    getters,
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/store/poster/index.js